import React from 'react';
import './App.css';
import VideoBackground from './VideoBackground';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faTiktok, faPatreon, faYoutube, faApple } from '@fortawesome/free-brands-svg-icons';

function App() {

  return (
    <div className="App">
      <VideoBackground />

    <div className="content-section container">
      <h1>Bio</h1>
      <hr />
      <div className="bio-content">
        <img
          src="https://www.davidaaroncampos.com/profile.jpg"
          alt="David Aaron Campos"
          className="bio-photo"
        />
        <div className="bio-text">
          <p>daarc is an electronic music project by producer David Aaron Campos.</p>
          <p>Growing up in Tijuana, Mexico, David began his creative journey as an abstract painter and heavy-metal drummer. In the last several years, his artistry expanded to encompass piano, synthesis, sampling, and music production.</p>
          <p>Now based in New York City, David draws inspiration from a broad spectrum of legendary musicians, including Frédéric Chopin, Erik Satie, Carlos Santana, Hans Zimmer, Deadmau5, Nils Frahm, Jabeau, Flume, and Odesza, creating music that merges classical elegance with modern electronic fvckery.</p>
        </div>
      </div>
    </div>


      <div id="music-section" className="content-section container">
        <h1>Music</h1>
        <hr />
        <div className="track-list">
          <iframe
            className="track-embed"
            src="https://open.spotify.com/embed/track/4AIV6Hm0Y5VOtEWX5zCn6W?utm_source=generator&theme=0"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            title="Track 1"
          ></iframe>
          <iframe
            className="track-embed"
            src="https://open.spotify.com/embed/track/6l8WLHkDo5oD3g3fDRVW2p?utm_source=generator&theme=0"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            title="Track 2"
          ></iframe>
          <iframe
            className="track-embed"
            src="https://open.spotify.com/embed/track/5jW8ESqhEx9WZ0RR5dmaIb?utm_source=generator&theme=0"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            title="Track 3"
          ></iframe>
          <iframe
            className="track-embed"
            src="https://open.spotify.com/embed/track/2saYlobCjd136iOx4T9po6?utm_source=generator&theme=0"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            title="Track 4"
          ></iframe>
          <iframe
            className="track-embed"
            src="https://open.spotify.com/embed/track/3uErvMFAAq7Uw4YQrKolkp?utm_source=generator&theme=0"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            title="Track 5"
          ></iframe>
          <iframe
            className="track-embed"
            src="https://open.spotify.com/embed/track/1JlO6FoBC10sCsmxLPmPyZ?utm_source=generator&theme=0"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            title="Track 6"
          ></iframe>
          <iframe
            className="track-embed"
            src="https://open.spotify.com/embed/track/0FFriwp0fUZdOkHjra33SV?utm_source=generator&theme=0"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            title="Track 7"
          ></iframe>
        </div>
      </div>

     

      <div className="social-media-links container">
        <a href="https://instagram.com/daarcmusic" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} size="2x" />
        </a>
        <a href="https://www.tiktok.com/@daarcmusic" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faTiktok} size="2x" />
        </a>
        <a href="https://www.patreon.com/daarcmusic" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faPatreon} size="2x" />
        </a>
        <a href="https://www.youtube.com/@daarcmusic" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faYoutube} size="2x" />
        </a>
        <a
          href="https://music.apple.com/us/artist/daarc/1682783601"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faApple} size="2x" />
        </a>
      </div>
    </div>
  );
}

export default App;
